/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

angular
    .module("ROGER")
    .config([
        "$routeProvider", "$locationProvider",
        function ($routeProvider, $locationProvider) {
            $routeProvider
                .when("/", {
                    controller: "DashboardController",
                    template: require("./Dashboard/Dashboard.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        hasPermissions: ['$q', '$user', '$location', function (q, user, location) {
                            if (user.isAuthenticated && !user.hasPermissions) {
                                location.path('/no-permissions');
                                return q.reject();
                            }
                        }],
                        tradeInApproval: ['$q', '$user', '$location', function (q, user, location) {
                            if (user.isAuthenticated &&
                                user.isTradeInApproval &&
                                !user.isModelAvailabilityReader &&
                                !user.isOrderingReader &&
                                !user.isOrderingManager
                            ) {
                                location.path('/trade-in/approval');
                                return q.reject();
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isModelAvailabilityReader &&
                                !user.isOrderingReader &&
                                !user.isOrderingManager
                            ) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/dashboard", {
                    controller: "DashboardController",
                    template: require("./Dashboard/Dashboard.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isModelAvailabilityReader &&
                                !user.isOrderingReader &&
                                !user.isOrderingManager) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/model-browser", {
                    controller: "ModelBrowserController",
                    template: require("./Model/ModelBrowser.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isModelAvailabilityReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/model-eta-browser", {
                    controller: "ModelETABrowserController",
                    template: require("./Model/ModelETABrowser.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isModelAvailabilityReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/bonus-cars", {
                    controller: "BonusCarsController",
                    template: require("./Bonus/BonusCars.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isModelAvailabilityReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/invoices", {
                    controller: "InvoicesController",
                    template: require("./Invoice/Invoices.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isInvoiceReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/reservations", {
                    controller: "ReservationsController",
                    template: require("./Reservation/Reservations.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/sales-orders/detail", {
                    controller: "SalesOrderDetailController",
                    template: require("./Sale/SalesOrderDetail.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/sales-orders/edit", {
                    controller: "SalesOrderLineEditController",
                    template: require("./Sale/SalesOrderLineEdit.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/sales-orders", {
                    controller: "SalesOrdersController",
                    template: require("./Sale/SalesOrders.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/sales-order-requests", {
                    controller: "SalesOrderRequestsController",
                    template: require("./Event/SalesOrderRequests.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/sales-order-requests-model-change", {
                    controller: "SalesOrderRequestModelChangeController",
                    template: require("./Event/SalesOrderRequestModelChange.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/cars-to-retail", {
                    controller: "CarsToRetailController",
                    template: require("./Car/CarsToRetail.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/retails", {
                    controller: "RetailsController",
                    template: require("./Retail/Retails.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/car-info", {
                    controller: "CarInfoController",
                    template: require("./Car/CarInfo.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/shopping-cart", {
                    controller: "ShoppingCartController",
                    template: require("./Shopping/ShoppingCart.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/limits", {
                    controller: "RetailerLimitController",
                    template: require("./Retail/Limits.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/reports", {
                    controller: "ReportsController",
                    template: require("./Report/Reports.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isReportReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/trade-in", {
                    controller: "TradeInController",
                    template: require("./TradeIn/TradeIn.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/trade-in/detail", {
                    controller: "TradeInDetailController",
                    template: require("./TradeIn/Detail/TradeInDetail.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isOrderingManager && !user.isOrderingReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/trade-in/approval", {
                    controller: "TradeInApprovalController",
                    template: require("./TradeInApproval/TradeInApproval.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isTradeInApproval) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .when("/no-permissions", {
                    controller: "NoPermissionsController",
                    template: require("./NoPermissions/NoPermissions.html"),
                    resolve:{
                        hasPermissions: ['$q', '$user', '$location', function (q, user, location) {
                            if (user.isAuthenticated && user.hasPermissions) {
                                location.path('/');
                                return q.reject();
                            }
                        }]
                    }
                })
                .otherwise({
                    controller: "DashboardController",
                    template: require("./Dashboard/Dashboard.html"),
                    resolve: {
                        authenticate: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authenticated");
                            }
                        }],
                        hasPermissions: ['$q', '$user', '$location', function (q, user, location) {
                            if (user.isAuthenticated && !user.hasPermissions) {
                                location.path('/no-permissions');
                                return q.reject();
                            }
                        }],
                        tradeInApproval: ['$q', '$user', '$location', function (q, user, location) {
                            if (user.isAuthenticated &&
                                user.isTradeInApproval &&
                                !user.isModelAvailabilityReader &&
                                !user.isOrderingReader &&
                                !user.isOrderingManager
                            ) {
                                location.path('/trade-in/approval');
                                return q.reject();
                            }
                        }],
                        authorize: ['$q', '$user', function (q, user) {
                            if (!user.isModelAvailabilityReader &&
                                !user.isOrderingReader &&
                                !user.isOrderingManager
                            ) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                });

            $locationProvider.html5Mode(true);
        }
    ]);